var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 62,
    viewBox: "0 0 78 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79004 1.6C3.79004 0.716345 4.50638 0 5.39004 0H27.4867C28.3703 0 29.0867 0.716345 29.0867 1.6V7.29398C29.0867 8.17763 29.803 8.89398 30.6867 8.89398H34.0872H35.9736C37.276 8.89398 38.0328 10.3668 37.2744 11.4256L36.4778 12.5379C36.1774 12.9574 35.693 13.2062 35.177 13.2062H5.39004C4.50638 13.2062 3.79004 12.4899 3.79004 11.6062V1.6Z",
    fill: "#A1ABBB",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2347C0 19.1302 0.895431 18.2348 2 18.2348H33.3564C33.9564 18.2348 34.5247 17.9654 34.9045 17.501L42.8346 7.80509C43.2145 7.34065 43.7828 7.07129 44.3828 7.07129L76 7.07129C77.1046 7.07129 78 7.96672 78 9.07129V59.0713C78 60.1759 77.1046 61.0713 76 61.0713H2C0.89543 61.0713 0 60.1759 0 59.0713V20.2347Z",
    fill: "#E6EBF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80762 4.24258C3.80762 3.35892 4.52396 2.64258 5.40762 2.64258H24.7687C25.6524 2.64258 26.3687 3.35892 26.3687 4.24258V9.75934C26.3687 10.643 27.0851 11.3593 27.9687 11.3593H32.3356C33.606 11.3593 34.3697 12.7687 33.676 13.833L33.0071 14.8593C32.7118 15.3124 32.2075 15.5857 31.6666 15.5857H5.40762C4.52396 15.5857 3.80762 14.8693 3.80762 13.9857V4.24258Z",
    fill: "#E6EBF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.0ce5301e.svg";
export { ForwardRef as ReactComponent };